import React, { FC } from 'react'
import { makeStyles } from 'tss-react/mui'
import { useRouter } from 'next/router'

import {
  DEFAULT_PER_PAGE_NEW_SRP,
  getValidSearchQuery,
  SearchFocusType,
} from '@src/utils/searchUtils'

import { useSearchContext } from '@src/routes/NewSearchResults/SearchContext'
import SearchResultsCount from '@src/routes/NewSearchResults/SearchResultsCount/SearchResultsCount'
// import SearchResultsSortBar from '../SearchResultsSortBar/SearchResultsSortBar'
import { useSearchQuery } from '@src/pages/[country]/[language]/search/[searchTerm]'

const useStyles = makeStyles()((theme) => ({
  desktopMenu: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    minHeight: '2rem',
    gap: theme.spacing(1),
    padding: theme.spacing(2, 0),
    marginTop: theme.spacing(4),
  },
  leftSection: {
    display: 'flex',
    alignItems: 'center',
  },
  rightSection: {
    display: 'flex',
    alignItems: 'center',
  },
}))

const DesktopSearchResultsMenu: FC = () => {
  const { classes } = useStyles()
  const { metadata } = useSearchContext()
  const [query] = useSearchQuery()

  const router = useRouter()
  const validSearchQuery = getValidSearchQuery({
    focus: router.query.focus,
    term: router.query.term,
  })

  const currPage = query.page ? Number(query.page) : 1
  const resultCount = metadata.count ?? metadata.itemCount ?? 0
  const perPage =
    router.query.focus === SearchFocusType.Products ||
    router.query.focus === SearchFocusType.B2B
      ? DEFAULT_PER_PAGE_NEW_SRP
      : metadata.perPage

  return (
    <div className={classes.desktopMenu} data-testid="desktop-srp-menu">
      <div className={classes.leftSection}>
        <SearchResultsCount
          currPage={currPage}
          perPage={perPage}
          resultCount={resultCount}
          searchTerm={validSearchQuery.term}
          searchType={validSearchQuery.focus}
        />
      </div>
      {/* <div className={classes.rightSection}>
        <SearchResultsSortBar />
      </div> */}
    </div>
  )
}

export default DesktopSearchResultsMenu
